import { useT } from "@/content/landing";
import { Reveal } from "./Reveal";
import expertReview from "@/assets/expert-review.jpg";
export function HowItWorks() {
  const t = useT();
  return <section id="ablauf" className="bg-[#FAFBFC] py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="grid items-end gap-8 lg:grid-cols-[0.8fr_1.2fr]">
          <Reveal>
            <h2 className="max-w-md text-2xl font-bold text-[#0F172A] sm:text-3xl">
              {t.how.title}
            </h2>
          </Reveal>
          <Reveal delay={70}>
            <div className="h-52 overflow-hidden rounded-3xl border border-black/[0.06] sm:h-64">
              <img src={expertReview} alt="Experte bei der persönlichen Prüfung eines digitalen Unternehmensberichts" loading="lazy" width={1536} height={1024} className="h-full w-full object-cover object-center" />
            </div>
          </Reveal>
        </div>
        <ol className="mt-12 grid gap-5 md:grid-cols-3">
          {t.how.steps.map((step, i) => <Reveal as="li" key={step.title} delay={i * 70}>
              <div className="h-full rounded-2xl border border-black/5 bg-white p-6">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold text-white" style={{
              backgroundImage: "linear-gradient(135deg,#3B82F6,#60A5FA,#4ADE80)"
            }}>
                  {i + 1}
                </span>
                <h3 className="mt-4 text-base font-semibold text-[#0F172A]">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#94A3B8]">{step.body}</p>
              </div>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}